import { useState } from 'react';
import SocialApi from '../api/social';

// [loggingOut, logout]: ends the session, then the sign in page
export default function useLogout() {
  const [loggingOut, setLoggingOut] = useState(false);
  const logout = async () => {
    setLoggingOut(true);
    try {
      await SocialApi.logout();
    } finally {
      window.location.assign('/login');
    }
  };
  return [loggingOut, logout];
}
